import {applySavedSelections, createExportFieldPrefs} from '@/lib/exportFieldPrefs';

/** Shared-map export field prefs, stored under `sharedMapExportFields` on the user's doc. */
const {saveExportFieldSelections, loadExportFieldSelections} = createExportFieldPrefs(
  'sharedMapExportFields',
  'shared-map',
);

export {
  applySavedSelections,
  saveExportFieldSelections,
  loadExportFieldSelections,
};
